import { SignInBrandLogo, useBranding } from '@l2u/web-shared';
import { supportEmailOf } from '@l2u/shared/brandingDefaults';

/**
 * A driver whose own compliance questionnaire passed its deadline unsubmitted.
 * A driver is judged on their own questionnaires only — their company being
 * locked never lands them here.
 *
 * Reached only after identity is proven (see CompanyLocked). No "email me a new
 * sign-in link" button: it would loop straight back into the same lock.
 */
export function DriverLocked() {
  const { branding } = useBranding();
  const supportEmail = supportEmailOf(branding);
  return (
    // `driver-portal` opts this page into the phone touch-target rules in
    // index.css — see DriverShell.
    <div className="driver-portal flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <SignInBrandLogo align="center" className="mb-3" />
        <h1 className="mt-2 text-lg font-semibold text-slate-900">Your account is locked</h1>
        <p className="mt-2 text-sm text-slate-600">
          A compliance questionnaire we sent you wasn’t submitted by its deadline, so access to the
          portal has been paused. Contact your administrator to unlock your account — they’ll reset
          the deadline so you can complete it.
        </p>
        <p className="mt-5 text-sm text-slate-500">
          Need help? Email{' '}
          <a href={`mailto:${supportEmail}`} className="text-blue-600 hover:underline">
            {supportEmail}
          </a>
          .
        </p>
      </div>
    </div>
  );
}
